export default __webpack_public_path__ + "fall-river.svg";